export { BaseAiTextarea } from "./base-ai-textarea/base-ai-textarea";

export { AiTextarea } from "./ai-textarea/ai-textarea";
export type { AiTextareaProps } from "./ai-textarea/ai-textarea";
